const config = {
  "region": "eu-west-2",
  "UploadBucket": "countpicula-countpicula-app-delivery-uploadbucket-ghxhjhcalqsj",
  "UserBucket": "countpicula-countpicula-app-delivery-userbucket-jsg4tamhgtb7",
  "TransformBucket": "countpicula-countpicula-app-deliv-transformbucket-ferhs009yoh3",
  "TemplateBucket": "countpicula-countpicula-app-delive-templatebucket-1ctuve8jt06gl",
  "UserPoolID": "eu-west-2_coK0vp42s",
  "ClientId": "3k56ca0sgtsue8cva4k4mjd4qh",
  "IdentityPoolId": "eu-west-2:3da3aaa6-fe21-4159-89d6-94c9207365f5",
  "UserTable": "app_UserInfo",
  "PaymentTable": "app_PaymentInfo",
  "login": "cognito-idp.eu-west-2.amazonaws.com/eu-west-2_coK0vp42s",
  "APIRoot": "https://jrsmwvqks4.execute-api.eu-west-2.amazonaws.com/Prod/",
  "paypalClientId": "ARh5E2LVSRELtsha1-nAZhGINZtEQ7imQqYBL2BoBollE9c5HJC1Qy4Jq6Tyo0w3W7M1dhLqckSxE1vF"
};
export default config;



// WEBPACK FOOTER //
// ./src/utils/app_config.js